<template>
  <div class="score">
    <div class="ele-table-tool ele-table-tool-default">
      <el-button @click="addScore" type="primary" icon="el-icon-plus" class="ele-btn-icon">添加 </el-button>
      <el-button @click="removeScore" type="danger" icon="el-icon-delete" class="ele-btn-icon">删除 </el-button>
      <el-button type="primary" @click="$refs.scoreTable.reload()" class="ele-btn-icon">重置 </el-button>
    </div>
    <ele-data-table ref="scoreTable" :config="scoreTable" :choose.sync="scoreChoose" highlight-current-row height="calc(92vh - 200px)">
      <template #default="{ index }">
        <el-table-column type="selection" width="45" align="center" fixed="left" />
        <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
        <el-table-column prop="score" label="分值" show-overflow-tooltip />
        <el-table-column prop="createTime" label="录入时间" show-overflow-tooltip />
        <el-table-column prop="teacherName" label="操作人" show-overflow-tooltip />
      </template>
    </ele-data-table>
    <!--添加分值-->
    <el-dialog title="添加分值" :visible.sync="showEdit" width="400px" :destroy-on-close="true" :lock-scroll="false">
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="82px" @keyup.enter.native="saveGeneral">
        <el-form-item label="分值:" prop="score">
          <el-input v-model="editForm.score" placeholder="请输入分值" clearable />
        </el-form-item>
        <el-form-item label="分值性质：">
          <el-radio-group v-model="editForm.type">
            <el-radio label="1">加分</el-radio>
            <el-radio label="2">减分</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="saveScore">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { deleteScoreByIdS, saveScore } from '@/config/api';

  export default {
    name: 'Score',
    data() {
      return {
        classId: null,
        scoreTable: {
          // 表格配置
          url: '/educationExamine/getItemScoreList',
          where: {},
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        scoreChoose: [],
        showEdit: false,
        editForm: {},
        editRules: {
          score: [{ required: true, message: '请输入分值', trigger: 'blur' }],
          type: [{ required: true, message: '请选择分值性质', trigger: 'change' }],
        },
      };
    },
    methods: {
      addScore() {
        this.editForm = {};
        this.showEdit = true;
      },
      removeScore() {
        if (this.scoreChoose.length === 0) return this.$message.error('请至少选择一条数据');
        let ids = this.scoreChoose.map((d) => d.id);
        this.$confirm('确定要删除选中项吗?', '提示', { type: 'warning' }).then(() => {
          let data = new FormData();
          data.append('ids', ids);
          deleteScoreByIdS(data).then((res) => {
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: '已删除' });
              this.$refs.scoreTable.reload();
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        });
      },
      saveScore() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            saveScore(formData).then((res) => {
              if (res.data.resCode == 200) {
                loading.close();
                this.$message({ type: 'success', message: res.data.resMsg });
                this.showEdit = false;
                this.$refs.scoreTable.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
    },
  };
</script>

<style scoped>
  .score {
    margin-top: 10px;
  }
</style>
